/**
 * SWR helper to split the individual api results list that swr returns into 1 single results list combining all page results and a total *count* key
 * @param {array} data
 * @returns Pagination object
 */
const getPaginationResults = (data: any[]) => {
  if (data.length)
    return data.length > 1
      ? data.reduce((accumulator: any, currentValue: any) => {
          return {
            ...accumulator,
            count: accumulator.count,
            next: currentValue.next,
            results: [
              ...(accumulator.results || []),
              ...(currentValue.results || [])
            ]
          };
        })
      : { ...data[0], results: data[0]?.results, count: data[0]?.count };
};

export default getPaginationResults;
